import { render, staticRenderFns } from "./SelectInputConfig.vue?vue&type=template&id=b65a1d60&scoped=true&"
import script from "./SelectInputConfig.vue?vue&type=script&lang=js&"
export * from "./SelectInputConfig.vue?vue&type=script&lang=js&"
import style0 from "./SelectInputConfig.vue?vue&type=style&index=0&id=b65a1d60&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b65a1d60",
  null
  
)

export default component.exports